export default {
    STUDENTS_LOGININ: "students_loginIn",
    STUDENTS_LOGINOUT: "students_loginOut",
    LOGINOUT:'loginOut',
    STUDENTS_SERVERURL: "students_serverUrl",
    USERBINDINFO: 'userBindInfo',//用户绑定信息
    USERINFO: 'userInfo',
    TEACHER: "teacher",
    ROUTERMESS: "routermess",
    SELFTRANININGLIST: "selfTrainingList", //自主练习查询题目
    TOPIC_LIST: "topicList", //自主训练题目列表

    TOPIC_ANS_STATUS: "topicAnsStatus", //题目答题状态修改
    TOPIC_DETAIL_MODIFY: "topicDetailModify", //题目详情修改
    SIMULATEDTRAININGLIST: "simulatedTrainingList", //模拟训练查询题目
    GETEXAMPAPERGROUPLISTBYPAGE: "getExamPaperGroupListByPage", //模拟训练分组列表
    GETEXAMPAPERPOSITIONS: "getExamPaperPositions", //获取试卷岗位列表
    GETOBJECTLIST: "getobjectlist", //获取大数据列表
    GETCERTIFICATESUMMERDATALIST: "getcertificatesummerdatalist", //总账列表
    GETSUBJECTBYTYPE: "getsubjectbytype", //科目类型获取科目列表
    GETCERTIFICATEDETAILDATALIST: "getcertificatedetaildatalist", //明细列表
    GETCERTIFICATEBALANCEDATALIST: "getcertificatebalancedatalist", //科目余额列表
    GETSTUDENTLASTGRADE: "getstudentlastgrade", //自主训练最近一次成绩
    GETSTUDENTGRADELIST: "getstudentgradelist", //自主训练历史成绩
    GETTEAMLASTGRADE: "getteamlastgrade", //模拟训练最近一次团队成绩
    GETTEAMGRADELIST: "getteamgradelist", //模拟训练历史团队统计
    GETERRORQUESTIONLIST: "geterrorquestionlist", //错题分析
    PAPERCENTERLISTBUPAGE: "papercenterlistbypage", //教师-获取自主练习试卷列表

    EXAM_BASIC_INFO_VIEW: "examBasicInfoView", //试卷预览基本信息
    TOPICLOADED: "topicLoaded", //题目加载状态

    // SIMULATED_TOPIC_INFO:'simulatedTopicInfo',//模拟训练题目信息
    POSITIONID: "positionId",
    EXAMGROUPID: "examGroupId",

    CHATSTORYLIST: "chatStorylist", //聊天记录
    CHATHISTORYLIST: "chathistorylist", //聊天记录历史

    BIGDATAANALYST: "bigdataanalyst", //大数据岗位交卷

    GETEXAMSCHOOLCOMPETITIONTASKLIST: "getexamschoolcompetitiontasklist", //校内赛任务列表
    SAVEEXAMSCHOOLCOMPETITIONTASK: "saveexamschoolcompetitiontask", //保存校内赛任务
    GETAVAILABLECASELIST: "getavailablecaselist", //获取学校可用案例
    DELETEEXAMSCHOOLCOMPETITIONTASK: "deleteexamschoolcompetitiontask", //删除校内赛任务
    PUBLISHSCHOOLCOMPETITIONTASK: "publishschoolcompetitiontask", //发布校内赛任务
    GETCOMPETITIONMONITOR: 'getcompetitionmonitor',// 实时监控-团队
    GETINDIVIDUALCOMPETITIONMONITOR: 'getindividualcompetitionmonitor',// 实时监控-个人
    GETCOMPETITIONRANK:'getcompetitionrank',//总分排名
    GETCOMPETITIONDETAILRANK: 'getcompetitiondetailrank',//成绩明细
    CLEAR_MARK: "clearmark",
    SAVECASEAPPLY:'savecaseapply',//新增/修改申请订单
    PRACTICEERRORANALYSIS:'practiceerroranalysis',//教师 自主分析-错题分析
    GETSHOOLCOMPETITIONCASELIST:'getshoolcompetitioncaselist',//获取校园赛可购买案例
    PRACTICEPERSONALANALYSIS:'practicepersonalanalysis',//自主分析 - 个人练习分析
    PRACTICEPERSONALDETAIL:'practicepersonaldetail',//自主分析 - 个人练习分析 - 明细
    EMULATIONTEAMANALYSIS:'emulationteamanalysis',////模拟分析 - 团队练习分析
    EMULATIONTEAMANALYSISDETAIL:'emulationteamanalysisdetail',// -模拟分析 - 团队练习分析 - 明细
    EXAMERRORANALYSISDETAIL:'examerroranalysisdetail',//错题分析
    GETINDIVIDUALCOMPETITIONRANK:'getindividualcompetitionrank',//总分排名-个人
    GETINDIVIDUALCOMPETITIONDETAILRANK: 'getindividualcompetitiondetailrank',//成绩明细-个人
    EMULATIONPERSONALANALYSISDETAIL: 'emulationpersonalanalysisdetail',//-模拟分析 - 个人练习分析 - 明细
    GETEXAMPAPERPOSTIONS: 'getexampaperpostions',//-模拟分析 - 个人练习分析 - 岗位信息
    EMULATIONPERSONALANALYSIS: 'emulationpersonalanalysis',//-模拟分析 - 个人练习分析 - 折线图
};


// WEBPACK FOOTER //
// ./src/constants/types.js